import React, { useState, useEffect } from "react"
//redux
import { useDispatch, useSelector } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import FilterLayout from "./filter"
import moment from "moment"
import {
  setIsMobile,
  workReports,
  getprojectsummaryreportscreens,
  getprojectsummaryreport,
} from "store/actions"
import TableContainer from "./Table/table"
import { getTeamLookup } from "store/createTeam/action"
import { StartTime } from "pages/Reports/VerifyScreens/VerifyScreenCol"
import { getHoursReport, getApprovesTeamsReport, getRejectsTeamsReport } from "store/Teams/action"
import { StartDateactivity } from "pages/Reports/VerifyMyTeams/VerifyScreenCol"
import ApproveModal from "../../../components/Common/ApproveModal"
import RejectModal from "../../../components/Common/RejectModal"
import {
  groupDataByValue,
  calculateAverageTime,
  addDurationsAndFormat,
  sumofIdleHours,
} from "helpers/util"
import MobileView from "./MobileView/mobileView"
import TableAction from "./TableAction"
import ViewScreen from "./Screen/ViewScreen"
import ViewReports from "./Reports/ViewReports"

const HoursReport = () => {
  document.title = "Hours Report | TenderSoftware - Flexi TracBoard"
  const [hoursReportList, setHoursReportList] = useState([])
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const fromDate = moment(new Date(startDate)).format("YYYY-MM-DD")
  const toDate = moment(new Date(endDate)).format("YYYY-MM-DD")
  const [activeReportStatus, setActiveReportStatus] = useState({
    id: 1,
    label: "Daily Employee hours",
    value: "Daily Employee hours",
  })
  const [selectedclientId, setSelectedclientId] = useState({
    label: "All",
    value: "All",
  })
  const [selectedprojectId, setSelectedprojectId] = useState({
    label: "All",
    value: "All",
  })
  const [selectname, setSelectname] = useState([
    {
      label: "All",
      value: "11",
    },
  ])
  const [selectAgent, setSelectAgent] = useState([
    {
      label: "All",
      value: "All",
    },
  ])
  const [filtersubCategory, setfiltersubCategory] = useState([])
  const [activeName, setactiveName] = useState("ALL")
  const [sort, setSort] = useState({
    direction: "asc",
    accessor: "date",
  })
  const dispatch = useDispatch()
  const [supervisorFilter, setSupervisorFilter] = useState({
    id: 3,
    label: "Normal",
    value: "Normal",
  })

  const [handleAccordion, sethandleAccordion] = useState(false)
  const [ismodal, setismodal] = useState(false)
  const [ismodalMultipleOpen, setismodalMultipleOpen] = useState(false)
  const [ismodalMultipleOpenReport, setismodalMultipleOpenReport] =
    useState(false)
  const [handleAccordionReport, sethandleAccordionReport] = useState(false)
  const [handleAccordionReportMultiple, sethandleAccordionReportMultiple] =
    useState(false)
  const [handleAccordionReportSingle, sethandleAccordionReportSingle] =
    useState(false)
  const [verifyScreen, setverifyScreen] = useState(false)
  const [expandedRow, setExpandedRow] = useState(null)
  const [screenResponse, setscreenResponse] = useState([])
  const [rowClick, setRowClick] = useState(true)
  const [sortdata, SetSortdata] = useState([])
  const [multipleClientFilters, setmultipleClientFilters] = useState([])
  // State for approve/reject modals
  const [approveModal, setApproveModal] = useState(false)
  const [rejectModal, setRejectModal] = useState(false)
  const [selectedEvaluation, setSelectedEvaluation] = useState(null)

  useEffect(() => {
    dispatch(getTeamLookup())
    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 921))
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const {
    isMobile,
    companySetting,
    screens,
    teamList,
    hoursReportsData,
    // reports,
    singleWorkReport,
    MultipleReports,
    approvalStatus,
    rejectionStatus,
  } = useSelector(state => ({
    isMobile: state.teams.isMobile,
    companySetting: state?.Login?.userDetails?.data,
    teamList: state?.createteam?.createTeamLookupList,
    emplList: state?.userlist?.userlist?.data,
    hoursReportsData: state?.teams?.hourReportSuccessList,
    screens: state?.timesheet?.getprojectsummaryreportscreens?.data,
    projectTeam: state?.createteam?.responseProjectTeam,
    singleWorkReport: state?.teams?.teamsWorkreport,
    // reports: state?.timesheet?.timeSheetReportSuccessList,
    MultipleReports: state?.timesheet?.getprojectsummaryreports?.data,
    approvalStatus: state?.teams?.teamApproveSuccessList?.statusCode,
    rejectionStatus: state?.teams?.teamRejectSuccessList?.statusCode,
  }))

  // date compare same or not
  const dateMatch = fromDate === toDate

  const filterProjectname = hoursReportsData?.datas?.map(el => ({
    ...el,
    dislayName: `${el.clientName}_${el.projectName}`,
    clientName: el.clientName,
    projectname: el.projectName,
    employeeName: el.user_name?.split("_")[0],
    empName: el.user_name?.split("_")[0],
  }))

  const groupByKey =  activeReportStatus.id === 5 || activeReportStatus.id === 6
    ? "userName" : supervisorFilter.id ===4 ? "supervisor" : "user_name"
  const groupedData = groupDataByValue(
    activeReportStatus.id == 2
      ? filterProjectname
      : hoursReportsData?.datas || [],
    activeReportStatus.id == 2 ? "dislayName" : groupByKey
  )

  useEffect(() => {
    setscreenResponse(screens)
  }, [screens])

  useEffect(() => {
    const reportsX = (hoursReportsData?.datas || [])?.map(el => {
      return {
        ...el,
        date: el.date,
        employeeName:
          supervisorFilter?.id == 4
            ? el?.user_name
            : el?.user_name?.split("_")[0],
        empName: el?.user_name?.split("_")[0],
        projectname: el?.projectName,
      }
    })

    // Map groupedData entries
    const ReportGrouped = Object.entries(groupedData).map(
      ([key, value], index) => {
        const averageStartTime = calculateAverageTime(
          value.map(entry => moment(entry.startTime).format("HH:mm:ss"))
        )
        const averageEndTime = calculateAverageTime(
          value.map(entry => moment(entry.endTime).format("HH:mm:ss"))
        )

        const {
          empId,
          projectname,
          headName,
          reportingLead,
          supervisor,
          clientId,
          projectId,
          accountId,
        } = value[0] || {}

        const data = value.map(entry => ({
          ...entry,
          employeeName: entry?.user_name?.split("_")[0] || "Unknown",
        }))

        const TotalHours = value.map(entry => entry?.totalHours)
        const LeaveHours = value.map(entry => entry?.leavehours)
        const InternalHours = value.map(entry => entry?.internalHours)
        const ClientHours = value.map(entry => entry?.clientHours)
        const AddTotalHours = addDurationsAndFormat(TotalHours)
        const AddInternalHours = addDurationsAndFormat(InternalHours)
        const AddLeaveHours = addDurationsAndFormat(LeaveHours)
        const AddClientHours = addDurationsAndFormat(ClientHours)
        const DurationList = value.map(entry => entry?.duration);
        const AddTotalDuration = addDurationsAndFormat(DurationList);

        return {
          ...value[0],
          user_name: key,
          empId,
          data,
          startTime: `2024-01-02T${averageStartTime}`,
          endTime: `2024-01-02T${averageEndTime}`,
          totalHours: AddTotalHours,
          clientHours: AddClientHours,
          internalHours: AddInternalHours,
          leavehours: AddLeaveHours,
          index,
          projectname,
          headName,
          reportingLead,
          supervisor,
          clientId,
          projectId,
          accountId,
          duration: AddTotalDuration
        }
      }
    )

    if (dateMatch && supervisorFilter?.id == 4) {
      setHoursReportList(ReportGrouped)
    } else {
      setHoursReportList(dateMatch ? reportsX : ReportGrouped)
    }
  }, [hoursReportsData, supervisorFilter, sort])

  // server side header click sorting
  const columnHeaderClick = column => {
    SetSortdata([]);
    switch (column.sortDirection) {
      case "none":
        setSort({ direction: "desc", accessor: column.id })
        handlePageValue({
          sortKey: column.id,
          sortValue: "desc",
        })
        break
      case "desc":
        setSort({ direction: "asc", accessor: column.id })
        handlePageValue({
          sortKey: column.id,
          sortValue: "asc",
        })
        break
      case "asc":
        setSort({ direction: "desc", accessor: column.id })
        handlePageValue({
          sortKey: column.id,
          sortValue: "desc",
        })
        break
    }
  }

  const handlecancel = () => {
    if (ismodal) {
      setismodal(!ismodal)
    }
    if (verifyScreen) {
      setverifyScreen(!verifyScreen)
    }
    if (ismodalMultipleOpen) {
      setismodalMultipleOpen(!ismodalMultipleOpen)
    }
    if (ismodalMultipleOpenReport) {
      setismodalMultipleOpenReport(!ismodalMultipleOpenReport)
    }
    sethandleAccordionReportSingle(false)
    sethandleAccordionReportMultiple(false)
    sethandleAccordionReport(false)
  }

  //expand table multiplpe screen
  const MultileScreen = list => {
    handleVerify(list, "multipleScreen")
  }
  //expand table multiplpe reports
  const MultileReports = list => {
    ProjectFullViewReport(list)
  }
  // overall fullview report
  const ProjectFullViewReport = list => {
    const selectedData = list
    // Prepare parameters for fetching project or user reports
    const params = {
      userId:
        supervisorFilter?.id == 4 
          ? selectedData?.userId
          : selectedData?.data?.[0]?.userId,
      fromDate: fromDate,
      toDate: toDate,
    }
    const projectParams = {
      ...params,
      userId: 0,
      clientId: selectedData?.clientId,
      projectId: selectedData?.projectId,
    }

    if (activeReportStatus?.id == 2) {
      dispatch(getprojectsummaryreport(projectParams))
    } else {
      dispatch(getprojectsummaryreport(params))
    }
    // Toggle modal state
    setismodalMultipleOpenReport(!ismodalMultipleOpenReport)
  }

  // single data show by date
  const toggleViewModal = value => {
    const selectedData = value
    if (!ismodal) {
      const params = {
        userId: selectedData.userId,
        date:
          activeReportStatus?.id == 2 || supervisorFilter?.id == 4
            ? fromDate
            : moment(selectedData.date).format("YYYY-MM-DD"),
        accountid:
          activeReportStatus?.id == 2 ? selectedData.accountId : undefined,
      }
      const projectParamsreport = {
        userId: selectedData?.userId,
        fromDate: fromDate,
        toDate: toDate,
        clientId:
          activeReportStatus?.id == 2 ? selectedData?.clientId : undefined,
        projectId:
          activeReportStatus?.id == 2 ? selectedData?.projectId : undefined,
      }
      if (activeReportStatus?.id == 2 && !dateMatch) {
        dispatch(getprojectsummaryreport(projectParamsreport))
      } else {
        dispatch(workReports(params))
      }
    }
    if (activeReportStatus?.id == 2 && !dateMatch) {
      setismodalMultipleOpenReport(!ismodalMultipleOpenReport)
    } else {
      setismodal(!ismodal)
    }
  }

  // Handle approve button click - opens confirmation modal
  const handleApproveClick = (item) => {
    setSelectedEvaluation(item)
    setApproveModal(true)
  }

  // Handle reject button click - opens confirmation modal
  const handleRejectClick = (item) => {
    setSelectedEvaluation(item)
    setRejectModal(true)
  }

  // Handle approve confirmation
  const handleApproveConfirm = () => {
    if (selectedEvaluation) {
      const approveData = {
        accountid: selectedEvaluation?.accountId,
        date: moment(selectedEvaluation?.startTime || selectedEvaluation?.date).format("YYYY-MM-DD"),
        starttime: selectedEvaluation?.startTime,
        endtime: selectedEvaluation?.endTime,
        approvedByUserId: JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id,
      }
      dispatch(getApprovesTeamsReport(approveData))
    }
    setApproveModal(false)
    setSelectedEvaluation(null)
  }

  // Handle reject confirmation
  const handleRejectConfirm = () => {
    if (selectedEvaluation) {
      const rejectData = {
        accountid: selectedEvaluation?.accountId,
        date: moment(selectedEvaluation?.startTime || selectedEvaluation?.date).format("YYYY-MM-DD"),
        starttime: selectedEvaluation?.startTime,
        endtime: selectedEvaluation?.endTime,
        approvedByUserId: JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id,
      }
      dispatch(getRejectsTeamsReport(rejectData))
    }
    setRejectModal(false)
    setSelectedEvaluation(null)
  }

  // Refresh list after approve/reject success
  useEffect(() => {
    if (approvalStatus === 200 || rejectionStatus === 200) {
      loadHoursReportScreen()
    }
  }, [approvalStatus, rejectionStatus])

  const handleVerify = (list, type) => {
    const selectedScreen = list
    var screenVerifyparams = {
      fromDate:
        type == "multipleScreen"
          ? fromDate
          : moment(
              selectedScreen.date == undefined ? fromDate : selectedScreen.date
            ).format("YYYY-MM-DD"),
      toDate:
        type == "multipleScreen"
          ? toDate
          : moment(
              selectedScreen.date == undefined ? fromDate : selectedScreen.date
            ).format("YYYY-MM-DD"),
      userId:
        type !== "multipleScreen"
          ? selectedScreen?.userId
          : supervisorFilter?.id == 4
          ? selectedScreen?.userId
          : selectedScreen?.data[0]?.userId,
    }

    var projectScreen = {
      ...screenVerifyparams,
      // userId: 0,
      fromDate:
        type == "multipleScreen" ? fromDate : dateMatch ? fromDate : fromDate,
      toDate: type == "multipleScreen" ? toDate : dateMatch ? fromDate : toDate,
      userId: type !== "multipleScreen" ? selectedScreen?.userId : 0,
      categoryId:
        type === "multipleScreen" ? selectedScreen?.clientId : undefined,
      subcategoryId:
        type === "multipleScreen" ? selectedScreen?.projectId : undefined,
      accountId:
        type !== "multipleScreen" ? selectedScreen?.accountId : undefined,
    }
    dispatch(
      getprojectsummaryreportscreens(
        activeReportStatus?.id == 2  ? projectScreen : screenVerifyparams
      )
    )
    if (type == "multipleScreen") {
      setismodalMultipleOpen(!ismodalMultipleOpen)
    } else {
      setverifyScreen(!verifyScreen)
    }
  }

  const columns = React.useMemo(() => 
    {
      if(activeReportStatus.id != 5 && activeReportStatus.id != 6){
    const result = [
      {
        Header: " ",
        accessor: " ",
        disableFilters: true,
        sort: false,
        hidden:
          (dateMatch && supervisorFilter?.id !== 4) ||
          (activeReportStatus?.id == 3 && supervisorFilter?.id == 3 && true),
        Cell: cellProps => {
          const indexValue = cellProps?.cell?.row?.original?.index
          return (
            <span>
              {expandedRow == indexValue ? (
                <span className="bx bx-minus-circle font-size-20" />
              ) : (
                <span className="bx bx-plus-circle font-size-20" />
              )}
            </span>
          )
        },
      },
      {
        Header: "Employee Name",
        accessor: "empName",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus.id == 2 && dateMatch ? false : true,
        sortDirection: sort.accessor === "empName" ? sort.direction : "none",
        footerType: true,
        totalType: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.cell.value?.length === 0
                ? "Default"
                : cellProps?.cell.value}
            </>
          )
        },
      },
      {
        Header:
          supervisorFilter?.id == 4
            ? "Supervisor Name"
            : activeReportStatus?.id === 2  
            ? "Client Name"
            : "Name",
        accessor: activeReportStatus?.id == 2 ? "clientName" : "user_name",
        disableFilters: true,
        sort: true,
        hidden: false,
        sortDirection:
          (sort.accessor === activeReportStatus?.id) == 2 
          ? "clientName"
          : "user_name"
          ? sort.direction
          : "none",
        footerType: true,
        totalType: true,
        style: {
          minWidth:
            supervisorFilter?.id == 4
              ? "150px"
              : activeReportStatus?.id == 2 
              ? "300px"
              : "300px",
          textAlign: "start",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: supervisorFilter?.id == 4 ? "150px" : "360px",
        },
        Cell: cellProps => {
          return (
            <div>
              {cellProps.cell.value?.length == 0
                ? "Default"
                : cellProps.cell.value}
            </div>
          )
        },
      },
      {
        Header: "Project Name",
        accessor: "projectname",
        disableFilters: true,
        sort: true,
        hidden:
          supervisorFilter.id == 4 || activeReportStatus?.id == 2
            ? false
            : true,
        sortDirection: "projectname" ? sort.direction : "none",
        footerType: false,
        Cell: cellProps => {
          return (
            <div
              style={{
                opacity:
                  supervisorFilter?.id == 4 || activeReportStatus?.id !== 2
                    ? 0
                    : 1,
                minWidth: activeReportStatus?.id == 2 ? "298px" : "170px",
                textAlign: "start",
                maxWidth: activeReportStatus?.id == 2 ? "298px" : "170px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {cellProps.cell.value?.length == 0
                ? "Default"
                : cellProps.cell.value}
            </div>
          )
        },
        style: {
          minWidth: activeReportStatus?.id == 2 ? "298px" : "170px",
          textAlign: "start",
          maxWidth: activeReportStatus?.id == 2 ? "298px" : "170px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Project Head",
        accessor: "headName",
        disableFilters: true,
        sort: true,
        hidden: supervisorFilter.id === 4 ? false : true,
        sortDirection: sort.accessor === "headName" ? sort.direction : "none",
        footerType: true,
        totalType: true,
        Cell: cellProps => {
          return supervisorFilter?.id !== 4 ? (
            <>
              {cellProps.cell.value?.length === 0
                ? "Default"
                : cellProps?.cell.value}
            </>
          ) : (
            <span style={{ opacity: 0 }}>Sankaranarayanan</span>
          )
        },
      },
      {
        Header: "Reporting Lead",
        accessor: "reportingLead",
        disableFilters: true,
        sort: true,
        hidden: supervisorFilter.id == 4 ? false : true,
        sortDirection:
          sort.accessor === "reportingLead" ? sort.direction : "none",
        width: isMobile && "",
        Cell: cellProps => {
          return (
            supervisorFilter?.id != 4 && (
              <>
                {cellProps.cell.value?.length == 0
                  ? "Default"
                  : cellProps?.cell.value}
              </>
            )
          )
        },
      },
      {
        Header: "Employee Id",
        accessor: "empId",
        disableFilters: true,
        sort: true,
        hidden: false,
        sortDirection: sort.accessor === "empId" ? sort.direction : "none",
        footerType: true,
        totalType: true,
        style: {
          minWidth: supervisorFilter.id !== 4 ? "130px" : "110px",
        },
        Cell: cellProps => {
          return activeReportStatus?.id == 2 || supervisorFilter?.id !== 4 ? (
            <div
              style={{
                opacity:
                  supervisorFilter?.id == 4 ||
                  (activeReportStatus?.id == 2 && !dateMatch)
                    ? 0
                    : 1,
              }}
            >
              {cellProps.cell.value}
            </div>
          ) : (
            <span style={{ opacity: 0 }}>HR-R-00008</span>
          )
        },
        Footer: info => (
          <>
            {supervisorFilter?.id == 4 ||
              activeReportStatus?.id == 1 ||
              (activeReportStatus?.id == 3 && !dateMatch && (
                <strong className="d-flex justify-content-end">Total: </strong>
              ))}
          </>
        ),
      },
      {
        Header: "Employee Name",
        accessor: "employeeName",
        disableFilters: true,
        sort: true,
        hidden:
          (activeReportStatus?.id == 2 && !dateMatch) ||
          supervisorFilter?.id == 4
            ? false
            : true,
        sortDirection:
          sort.accessor === "employeeName" ? sort.direction : "none",
        Cell: cellProps => {
          return activeReportStatus?.id !== 2 || supervisorFilter?.id !== 4 ? (
            <div
              style={{
                opacity: activeReportStatus?.id == 2 && !dateMatch ? 0 : 1,
              }}
            >
              {cellProps.cell.value}
            </div>
          ) : (
            <span style={{ opacity: 0 }}>HR-R-00008</span>
          )
        },
        footerType: true,
        totalType: true,
        style: {
          minWidth: "200px",
          textAlign: "start",
          maxWidth: "200px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Footer: info => (
          <>
            {supervisorFilter?.id == 4 && (
              <strong className="d-flex justify-content-end">Total: </strong>
            )}
          </>
        ),
      },
      {
        Header: "Date",
        accessor: "date",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus.id !== 1 || (dateMatch && true),
        sortDirection: sort.accessor === "date" ? sort.direction : "none",
        Cell: cellProps => {
          return dateMatch ? (
            <StartDateactivity {...cellProps} />
          ) : (
            <span style={{ opacity: 0 }}>2023-08-10</span>
          )
        },
        footerType: false,
        totalType: false,
        style: {
          minWidth: "100px",
        },
      },

      {
        Header: "Start Time",
        accessor: "startTime",
        disableFilters: true,
        sort: true,
        sortView: true,
        hidden: activeReportStatus.id !== 1 && true,
        sortDirection: sort.accessor === "startTime" ? sort.direction : "none",
        Cell: cellProps => {
          return <StartTime {...cellProps} />
        },
        footerType: false,
        totalType: false,
        style: {
          minWidth: "80px",
        },
      },
      {
        Header: "End Time",
        accessor: "endTime",
        disableFilters: true,
        sort: true,
        sortView: true,
        hidden: activeReportStatus.id !== 1 && true,
        sortDirection: sort.accessor === "endTime" ? sort.direction : "none",
        Cell: cellProps => {
          return <StartTime {...cellProps} />
        },
        Footer: info => (
          <>
             {activeReportStatus?.id !== 5 || activeReportStatus?.id !== 6 && (
            <strong className="d-flex justify-content-end">Total: </strong>
            )}
          </>
        ),
        footerType: true,
        totalType: true,
      },
      {
        Header: "Total Hours",
        accessor: "totalHours",
        disableFilters: true,
        sort: true,
        hidden: false,
        sortView: true,
        isSortedDesc: false, // Indicates if the current sorting direction is descending
        sortDirection: sort.accessor === "totalHours" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start text-primary">
              {sumofIdleHours("totalHours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
      },
      {
        Header: "Billable Hours",
        accessor: "clientHours",
        disableFilters: true,
        sort: true,
        hidden: supervisorFilter.id !== 4? false : true,
        sortView: true,
        sortDirection:
          sort.accessor === "clientHours" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start">
              {sumofIdleHours("clientHours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
      },
      {
        Header: "Non-Billable Hours",
        accessor: "internalHours",
        disableFilters: true,
        sort: true,
        sortView: true,
        hidden: supervisorFilter.id !== 4? false : true,
        sortDirection:
          sort.accessor === "internalHours" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start">
              {sumofIdleHours("internalHours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
      },
      {
        Header: "Leave Hours",
        accessor: "leavehours",
        disableFilters: true,
        sort: true,
        sortView: true,
        hidden: supervisorFilter.id !== 4? false : true,
        sortDirection: sort.accessor === "leavehours" ? sort.direction : "none",
        Footer: info => (
          <>
            <span className="d-flex justify-content-start">
              {sumofIdleHours("leavehours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
      },
      {
        Header: "Action",
        sort: false,
        style: {
          minWidth: "80px",
        },
        Cell: cellProps =>
          supervisorFilter.id !== 4 ? (
            <div
              role="button"
              style={{ cursor: "pointer" }}
              className="verify-screen-button"
            >
              <TableAction
                handleOnExpand={dateMatch ? toggleViewModal : MultileReports}
                handleVerify={dateMatch ? handleVerify : MultileScreen}
                cellProps={cellProps}
              />
            </div>
          ) : null,
      },
    ]
    return result
    }
  else{
    return[
      {
        Header: " ",
        accessor: " ",
        disableFilters: true,
        sort: false,
        hidden: false,
        Cell: cellProps => {
          const indexValue = cellProps?.cell?.row?.original?.index
          return (
            <span>
              {expandedRow == indexValue ? (
                <span className="bx bx-minus-circle font-size-20" />
              ) : (
                <span className="bx bx-plus-circle font-size-20" />
              )}
            </span>
          )
        },
      },
        {
          Header: "Employee Id",
          accessor: "empId",
          disableFilters: true,
          sort: true,
          hidden: dateMatch,
          Cell: ({ value }) => <span>{value}</span>, 
          footerType: false,
          totalType: false,
          style: { minWidth: "70px" },
        },
	      {
        Header: "Emp Name",
        accessor: "userName",
        disableFilters: true,
        sort: true,
        sortView: true,
        hidden: activeReportStatus?.id == 5 || activeReportStatus?.id == 6 ? false : true,
        sortDirection:
        sort.accessor === "userName" ? sort.direction : "none",
        footerType: true,
        totalType: false,
        style: {
              minWidth: "100px",
              textAlign: "start",
              maxWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
       },
	     {
          Header: "Client Name",
          accessor: "clientName",
          disableFilters: true,
          sort: true,
          hidden: dateMatch,
          Cell: ()=> <></>,
          footerType: false,
          totalType: false,
          style: {
              minWidth: "140px",
              textAlign: "start",
              maxWidth: "140px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
          },
        },
      
      {
        Header: "Project Name",
        accessor: "projectName",
        disableFilters: true,
        sort: true,
        sortView: true,
        hidden: activeReportStatus?.id == 5 || activeReportStatus?.id == 6 ? false : true,
        Cell: ()=> <></>,
        sortDirection:
        sort.accessor === "projectName" ? sort.direction : "none",
        footerType: true,
        totalType: false,
        style: {
              minWidth: "140px",
              textAlign: "start",
              maxWidth: "140px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
      },
	    {
        Header: "Approved By",
        accessor: "approvedBy",
        disableFilters: true,
        sort: true,
        sortView: true,
         Cell: ()=> <></>,
        hidden: activeReportStatus?.id == 5 || activeReportStatus?.id == 6 ? false : true,
        sortDirection:
          sort.accessor === "approvedBy" ? sort.direction : "none",
        footerType: true,
        totalType: false,
        style: {
              minWidth: "100px",
              textAlign: "start",
              maxWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
      },
      {
        Header: "Date",
        accessor: "date", 
        disableFilters: true,
        sort: true,
        hidden: false,
        Cell: ()=> <></>,
        footerType: false,
        totalType: false,
       style: {
              minWidth: "80px",
              textAlign: "start",
              maxWidth: "80px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
      },
	   {
        Header: "Start Time",
        accessor: "startTime",
        disableFilters: true,
        sort: true,
        sortView: true,
        hidden: !(activeReportStatus.id === 1 || activeReportStatus.id === 5 || activeReportStatus.id === 6),
        sortDirection: sort.accessor === "startTime" ? sort.direction : "none",
         Cell: ()=> <></>,
        footerType: false,
        totalType: false,
        style: {
              minWidth: "50px",
              textAlign: "start",
              maxWidth: "50px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
      },
      {
        Header: "End Time",
        accessor: "endTime",
        disableFilters: true,
        sort: true,
        sortView: true,
        hidden: !(activeReportStatus.id === 1 || activeReportStatus.id === 5 || activeReportStatus.id === 6),
        sortDirection: sort.accessor === "endTime" ? sort.direction : "none",
        // 
         Cell: ()=> <></>,
        Footer: info => (
          <>
             {activeReportStatus?.id !== 5 || activeReportStatus?.id !== 6 && (
            <strong className="d-flex justify-content-end">Total: </strong>
            )}
          </>
        ),
        footerType: true,
        totalType: true,
        style: {
              minWidth: "50px",
              textAlign: "start",
              maxWidth: "50px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
      },
	   {
        Header: "Total Duration",
        accessor: "duration",
        disableFilters: true,
        sort: false,
        hidden: false,
        sortView: true,
        hidden: activeReportStatus?.id == 5 || activeReportStatus?.id == 6 ? false : true,
        sortDirection:
        sort.accessor === "duration" ? sort.direction : "none",
        Cell: ({ value }) => <span>{value}</span>,
        footerType: true,
        totalType: true,
        style: {
              minWidth: "50px",
              textAlign: "start",
              maxWidth: "50px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
      },
	   {
        Header: "Comments",
        accessor: "comments",
        disableFilters: true,
        sort: true,
        sortView: true,
        hidden: activeReportStatus?.id == 5 || activeReportStatus?.id == 6 ? false : true,
        Cell: ()=> <></>,
        sortDirection:
        sort.accessor === "comments" ? sort.direction : "none",
        footerType: true,
        totalType: false,
        style: {
              minWidth: "100px",
              textAlign: "start",
              maxWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
      },
    ]; 
  }
  }, [
    activeReportStatus,
    supervisorFilter,
    sort,
    hoursReportList,
    isMobile,
    dateMatch,
    expandedRow,
  ])

  const handleSubmit = e => {
    e.preventDefault()
    onHandleFilterBtnClicked()
  }

  const onHandleFilterBtnClicked = () => {
    loadHoursReportScreen()
  }

  const loadHoursReportScreen = () => {
    const hoursreport = {
      empId: activeName?.label == "All" ? "" : activeName?.value,
      fromDate: fromDate,
      toDate: toDate,
      client:
        selectedclientId?.label == "All" || selectedclientId == null
          ? ""
          : selectedclientId?.id,
      project:
        selectedprojectId?.label == "All" || selectedprojectId == null
          ? ""
          : selectedprojectId?.id,
      reportType:
        activeReportStatus?.id == 3
          ? supervisorFilter?.id
          : activeReportStatus?.id,
      agent: selectAgent?.label == "All" || selectAgent == null
      ? ""
      : selectAgent?.id,
      export: false,
      sortKey: sort?.accessor,
      sortValue: sort?.direction,
    }
    dispatch(getHoursReport(hoursreport))
  }

  useEffect(() => {
    loadHoursReportScreen()
    setExpandedRow(null)
  }, [
    activeReportStatus,
    selectedprojectId,
    selectedclientId,
    activeName,
    dateMatch,
    supervisorFilter,
    selectAgent
  ])

  const handleReportFilter = data => {
    setActiveReportStatus(data)
    setExpandedRow(null)
    setSupervisorFilter({
      id: 3,
      label: "Normal",
      value: "Normal",
    })
    setSort({
      direction: "asc",
      accessor: activeReportStatus?.id == 1 ? "date" : "user_name",
    })
    SetSortdata([])
  }

  const handleSupervisorReportFilter = data => {
    setSupervisorFilter(data)
    setExpandedRow(null)
    setSort({
      direction: "asc",
      accessor: activeReportStatus?.id == 1 ? "date" : "user_name",
    })
  }

  // custom pagination page value and
  const handlePageValue = value => {
    const ProjectSortValues = activeReportStatus?.id == 2 && !dateMatch
    // Check if value.noChange is falsey before dispatching the action
    if (!value.noChange) {
      dispatch(
        getHoursReport({
          ...value,
          // sortKey: value.sortKey,
          sortKey:
            ProjectSortValues && value.sortKey === "user_name"
              ? "clientName"
              : value.sortKey === "employeeName" || value.sortKey === "empName"
              ? "user_name"
              : value.sortKey,
          // Determine sortValue based on value.sortValue or fallback to sort?.direction
          sortValue: value.sortValue ? value.sortValue : sort?.direction,
          // Determine empId based on activeName
          empId: activeName?.label == "All" ? "" : activeName?.value,
          // fromDate and toDate are presumably defined elsewhere in the code
          fromDate: fromDate,
          toDate: toDate,
          // Determine client based on selectedclientId
          client: selectedclientId?.label == "All" ? "" : selectedclientId?.id,
          // Determine project based on selectedprojectId
          project:
            selectedprojectId?.label == "All" ? "" : selectedprojectId?.id,
          // Determine reportType based on activeReportStatus and supervisorFilter
          reportType:
            activeReportStatus?.id == 3
              ? supervisorFilter?.id
              : activeReportStatus?.id,
          // Set export to false
          export: false,
        })
      )
    }
  }

  // get report summary
  const GetHourSummaryReport = e => {
    e.preventDefault()
    const hoursreportdownload = {
      empId: activeName?.label == "All" ? "" : activeName?.value,
      fromDate: fromDate,
      toDate: toDate,
      client: selectedclientId?.label == "All" ? "" : selectedclientId?.id,
      project: selectedprojectId?.label == "All" ? "" : selectedprojectId?.id,
      reportType:
        activeReportStatus?.id == 3
          ? supervisorFilter?.id
          : activeReportStatus?.id,
      agent: (selectAgent?.label == "All" || selectAgent == null) ? "" : selectAgent?.id,
      export: true,
    }
    dispatch(
      getHoursReport(
        hoursreportdownload,
        "export",
        activeReportStatus?.label.toLowerCase().replace(/\s/g, "_")
      )
    )
  }

  // maincategory to subcategory filter in useeffect
  useEffect(() => {
    setfiltersubCategory(teamList?.subCategoryLookup)
  }, [teamList])

  useEffect(() => {
    if (activeReportStatus?.id == 3 && supervisorFilter?.id == 3) {
      setRowClick(false)
      columns.pop()
    } else {
      setRowClick(true)
    }
  }, [activeReportStatus, supervisorFilter])

  // employee name
  const handleNameFilter = value => {
    setactiveName(value || "ALL")
  }

  useEffect(() => {
    // multiple report filter send viewroprt file --- start---
    const filterAddReports = MultipleReports?.projectSummaryList?.map(el => ({
      ...el,
      clientId: el?.tasks?.[0]?.clientId,
      userName: el?.tasks?.[0]?.userName,
      userId: el?.tasks?.[0]?.userId,
    }))

    const updatedClientFilters =
      selectedclientId?.id == undefined
        ? filterAddReports
        : filterAddReports?.filter(
            el => el.clientId === selectedclientId?.id
          ) || []

    const updatedProjectFilters =
      selectedprojectId?.id == undefined
        ? updatedClientFilters
        : updatedClientFilters?.filter(
            el => el.projectID === selectedprojectId?.id
          ) || []
    const filterUserIDReport =
      selectname?.id == undefined
        ? updatedProjectFilters
        : updatedProjectFilters
            ?.map(el => el)
            .filter(el => el.userId === selectname?.id)
    // multiple report filter send viewroprt file --- end---

    setmultipleClientFilters(
      activeReportStatus?.id == 2 ? filterUserIDReport : updatedProjectFilters
    )
  }, [
    MultipleReports,
    selectedclientId,
    selectedprojectId,
    selectname,
    activeReportStatus,
    screenResponse,
  ])

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title={"Hours Report"} breadcrumbItem={"Hours Report"} />

          <ViewScreen
            screens={screenResponse}
            isOpen={verifyScreen}
            toggle={e => handleVerify(e)}
            handlecancel={handlecancel}
            HoursReportPagesingle={true}
            handleAccordion={handleAccordionReportSingle}
            sethandleAccordion={sethandleAccordionReportSingle}
            selectedclientId={selectedclientId}
            selectedprojectId={selectedprojectId}
            selectname={selectname}
            activeReportStatus={activeReportStatus}
          />
          <ViewReports
            isOpen={ismodalMultipleOpenReport}
            toggle={e => MultileReports(e)}
            setismodal={setismodalMultipleOpenReport}
            handlecancel={handlecancel}
            activeReportStatus={activeReportStatus}
            SelectedDataReports={multipleClientFilters}
            handleAccordion={handleAccordionReportMultiple}
            sethandleAccordion={sethandleAccordionReportMultiple}
            HoursReportPage={false}
            selectedclientId={selectedclientId}
            selectedprojectId={selectedprojectId}
          />
          <ViewScreen
            screens={screenResponse}
            isOpen={ismodalMultipleOpen}
            toggle={e => MultileScreen(e)}
            handlecancel={handlecancel}
            handleAccordion={handleAccordionReportMultiple}
            sethandleAccordion={sethandleAccordionReportMultiple}
            HoursReportPagesingle={false}
            selectedclientId={selectedclientId}
            selectedprojectId={selectedprojectId}
            selectname={selectname}
            activeReportStatus={activeReportStatus}
          />
          <ViewReports
            isOpen={ismodal}
            toggle={e => toggleViewModal(e)}
            setismodal={setismodal}
            handlecancel={handlecancel}
            SelectedDataReports={singleWorkReport}
            HoursReportPage={true}
            handleAccordion={handleAccordionReport}
            sethandleAccordion={sethandleAccordionReport}
            selectedclientId={selectedclientId}
            selectedprojectId={selectedprojectId}
            activeReportStatus={activeReportStatus}
          />
          {/* Approve Confirmation Modal */}
          <ApproveModal
            show={approveModal}
            onDeleteClick={handleApproveConfirm}
            onCloseClick={() => {
              setApproveModal(false)
              setSelectedEvaluation(null)
            }}
            evaluationall={false}
          />
          {/* Reject Confirmation Modal */}
          <RejectModal
            show={rejectModal}
            onDeleteClick={handleRejectConfirm}
            onCloseClick={() => {
              setRejectModal(false)
              setSelectedEvaluation(null)
            }}
            showText="Are you sure you want to Reject this evaluation?"
            confirmationText="Yes, Reject"
          />
          <Card>
            <CardBody>
              <FilterLayout
                setStartDate={setStartDate}
                startDate={startDate}
                setEndDate={setEndDate}
                endDate={endDate}
                handleReportFilter={handleReportFilter}
                handleSubmit={handleSubmit}
                activeReportStatus={activeReportStatus}
                GetHourSummaryReport={GetHourSummaryReport}
                companySetting={companySetting}
                MainCategory={teamList?.categoryLookup}
                teams={teamList?.subCategoryLookup}
                setSelectedclientId={setSelectedclientId}
                setSelectedprojectId={setSelectedprojectId}
                SubCategory={filtersubCategory}
                handleNameDropdownFilter={handleNameFilter}
                handleSupervisorReportFilter={handleSupervisorReportFilter}
                supervisorFilter={supervisorFilter}
                setExpandedRow={setExpandedRow}
                selectname={selectname}
                setSelectname={setSelectname}
                selectAgent={selectAgent}
                setSelectAgent={setSelectAgent}
              />
              <Row>
                <Col xs="12">
                  <div className="p-0">
                    {(isMobile && dateMatch) || !isMobile ? (
                      <>
                        <div className="table-mobileView ">
                          <TableContainer
                            keyField="empId"
                            columns={columns}
                            data={hoursReportList || []}
                            isMobile={isMobile}
                            customPageSize={10}
                            totalCount={hoursReportsData?.count || 0}
                            handlePageValue={handlePageValue}
                            onHeaderClick={columnHeaderClick}
                            customPageSizeOptions
                            className="custom-header-css"
                            activeReportStatus={activeReportStatus}
                            footeraddition={true}
                            supervisorFilter={supervisorFilter}
                            setExpandedRow={setExpandedRow}
                            dateMatch={dateMatch}
                            onClick={rowClick}
                            expandedRow={expandedRow}
                            toggleViewModal={toggleViewModal}
                            MultileReports={MultileReports}
                            handleVerify={handleVerify}
                            MultileScreen={MultileScreen}
                            SetSortdata={SetSortdata}
                            sortdata={sortdata}
                            handleApprove={handleApproveClick}
                            handleReject={handleRejectClick}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {hoursReportList?.map((item, index) => {
                          return (
                            <MobileView
                              key={index}
                              user_name={item.user_name}
                              data={item.data || []}
                              sethandleAccordion={sethandleAccordion}
                              handleAccordion={handleAccordion}
                              keyId={item.index}
                              averageData={item}
                              supervisorFilter={supervisorFilter}
                              activeReportStatus={activeReportStatus}
                              handleOnExpand={toggleViewModal}
                              handleVerify={handleVerify}
                            />
                          )
                        })}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default HoursReport
